import { useState } from "react";
import CommonDialog from "src/components/Dialog/CommonDialog";
import { useEventBus } from "src/hooks/useEventBus";

export const DialogSubscriber = () => {
  const [dialogState, setDialogState] = useState({
    open: false,
    type: "info",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const showDialog = (payload) => {
    setDialogState({
      open: true,
      ...payload
    });
  };

  // Subscribe to the event
  useEventBus("dialog", showDialog);

  // confirm
  return (
    <CommonDialog
      open={dialogState.open}
      loading={loading}
      onClose={() =>  !loading && setDialogState({ ...dialogState, open: false })}
      {...dialogState}
      onOk={async () => {
        setLoading(true);
        try {
          await dialogState.onOk();
          setDialogState({ ...dialogState, open: false });
          dialogState.onFinish();
        } finally {
          setLoading(false);
        }
      }}
    />
  );
};
